"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var RecapturePopBig_1 = require("@/pages/recapture/components/RecapturePopBig");
var RecapturePopSmall_1 = require("@/pages/recapture/components/RecapturePopSmall");
var RecapturePopGlass_1 = require("@/pages/recapture/components/RecapturePopGlass");
var popup = function (props, flavor) {
    var analyticId = function (flavor, action) { return ({
        'data-recapture-action': action,
        'data-recapture-flavor': flavor,
        'data-recapture-name': 'recapture',
    }); };
    var popProps = {
        flavor: flavor, analyticId: analyticId,
        recaptureProps: props,
    };
    switch (flavor) {
        case 'recapsm': return (React.createElement(RecapturePopSmall_1.default, __assign({}, popProps)));
        case 'recaplg': return (React.createElement(RecapturePopBig_1.default, __assign({}, popProps)));
        case 'recap3': return (React.createElement(RecapturePopGlass_1.default, __assign({}, popProps)));
        default: return (React.createElement(RecapturePopGlass_1.default, __assign({}, popProps)));
    }
};
exports.default = popup;
